/** @format */

export default {
  props: ['value'],
  data() {
    return {
      checked: true
    };
  },
  watch: {
    value(val: any) {
      let self: any = this;
      let value = Number(val);
      if (!isNaN(value)) {
        if (value === 0) {
          self.checked = false;
        } else if (value === 1) {
          self.checked = true;
        }
      } else {
        self.checked = false;
        console.log('传入数据不合法');
      }
    }
  },
  methods: {
    onChange() {
      let self: any = this;
      if (self.checked) {
        self.checked = false;
        self.$emit('input', 0);
      } else if (!self.checked) {
        self.checked = true;
        self.$emit('input', 1);
      }
    }
  },
  beforeMount() {
    let self: any = this;
    let value = Number(self.value);
    if (!isNaN(value)) {
      if (value === 0) {
        self.checked = false;
      } else if (value === 1) {
        self.checked = true;
      }
    } else {
      self.checked = false;
      // console.log('传入数据不合法')
    }
  },
  render(h: any) {
    let self: any = this;
    return (
      <a-switch checked={self.checked} onChange={self.onChange}>
        <a-icon type="check" slot="checkedChildren"></a-icon>
        <a-icon type="close" slot="unCheckedChildren"></a-icon>
      </a-switch>
    );
  }
};
